const isLocalHost = (host: string) => host === "localhost" || host === "127.0.0.1";

export function getSafeDemoReturnUrl(raw: string | null | undefined): string | null {
    if (!raw) return null;
    try {
        const url = new URL(raw);
        const host = url.hostname.toLowerCase();
        const allowedHost =
            isLocalHost(host) ||
            host === "scoutout.co" ||
            host.endsWith(".scoutout.co") ||
            host.endsWith(".hosted.app");
        if (!allowedHost) return null;
        if (url.protocol === "http:") return isLocalHost(host) ? url.toString() : null;
        return url.protocol === "https:" ? url.toString() : null;
    } catch {
        return null;
    }
}

export function buildLandingResultUrl(
    returnUrl: string,
    params: { report_id: string; candidate_id: string; job_question_id: string },
): string {
    const url = new URL(returnUrl);
    url.searchParams.set("report_id", params.report_id);
    url.searchParams.set("candidate_id", params.candidate_id);
    url.searchParams.set("job_question_id", params.job_question_id);
    return url.toString();
}
